var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 9.5V8h1.5v1.5h-1.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.75 2.25H12c.966 0 1.75.784 1.75 1.75v8A1.75 1.75 0 0 1 12 13.75H4A1.75 1.75 0 0 1 2.25 12V4c0-.966.784-1.75 1.75-1.75h.25V1h1.5v1.25h4.5V1h1.5v1.25zM4 3.75a.25.25 0 0 0-.25.25v1.25h8.5V4a.25.25 0 0 0-.25-.25H4zM3.75 12V6.75h8.5V12a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export default ForwardRef;